module.exports = __webpack_public_path__ + "static/media/css3.a70a7e3e.svg";